<template>
  <v-layout row wrap class="list-section mx-3 mt-2 pa-3">
    <vue-headful v-bind:title="ticket.subject" />
    <v-toolbar flat color="toolbarColor">
      <v-toolbar-title style="margin-left: -27px">Ticket No: {{ticket.ticket_no}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="back" color="btnColor" right flat>Back</v-btn>
      <!-- <v-btn v-if="ticket.status == 'Open'" icon :to="`/ticket/create?id=${ticket._id}`">
        <v-icon color="orange">edit</v-icon>
      </v-btn> -->
    </v-toolbar>

    <v-flex xs12 sm12>
      <h4>Subject: <span class="font-weight-regular">{{ticket.subject}}</span></h4>
    </v-flex>
    <v-flex xs12 sm12>
      <p class="font-weight-bold mb-0 mt-2">Description: <div v-html="ticket.description"></div></p>
    </v-flex>
    <v-flex xs12 sm12>
      <h4>Posted On: <span class="font-weight-regular">{{ticket.createdAt | moment("DD MMMM YYYY") }}</span></h4>
    </v-flex>
    <v-flex xs12 sm12 class="my-2">
      <v-divider></v-divider>
    </v-flex>
    <v-flex xs12 sm12 v-if="ticket.replies && ticket.replies.length > 0" >
      <h3 class="primary--text">Comments</h3>
    </v-flex>
    <v-flex xs12 sm12 v-if="ticket.replies" v-for="reply in ticket.replies" :key="reply._id">
      <div class="font-weight-bold">Posted by <span class="font-weight-regular">{{reply.userId.firstName}} {{reply.userId.lastName}}</span> at <span class="font-weight-regular caption grey--text">{{reply.createdAt | moment("DD MMMM YYYY h:mm:ss a") }}</span></div>
      <div v-html="reply.comments"></div>
      <v-divider class="my-2"></v-divider>
    </v-flex>

    <v-flex xs12 sm12 class="my-2" v-if="ticket.status == 'Open'">
      <h3 class="primary--text">Update your Ticket Here</h3>
    </v-flex>
    <v-flex xs12 sm12 class="my-2" v-else-if="ticket.status == 'Closed'">
      <h3 class="red--text">Your Ticket is Closed, Open a new Ticket</h3>
    </v-flex>
    <v-flex xs12 class="mt-2" v-if="ticket.status == 'Open'">
      <ckeditor v-model="comment" id="comment"
        data-vv-name="comment"  label="Reply" :editor="editor" :config="editorConfig"></ckeditor>
    </v-flex>
    <v-flex xs12 v-if="ticket.status == 'Open'">
      <v-btn class="primary" @click="save" :loading="loader">
        <v-icon left>save</v-icon>Submit
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor from '@ckeditor/ckeditor5-vue2';
export default {
  name: "TicketDetailsComponent",
  computed: {
    ...mapGetters(["host"]),
    ...mapGetters(["user"])
  },
  components: {
    CKEditor,
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        image: {
            styles: [
                'alignLeft', 'alignCenter', 'alignRight'
            ],
            resizeOptions: [
                {
                    name: 'imageResize:original',
                    label: 'Original',
                    value: null
                },
                {
                    name: 'imageResize:50',
                    label: '50%',
                    value: '50'
                },
                {
                    name: 'imageResize:75',
                    label: '75%',
                    value: '75'
                }
            ],
            toolbar: [
                'imageStyle:alignLeft', 'imageStyle:alignCenter', 'imageStyle:alignRight',
                '|',
                'imageResize',
                '|',
                'imageTextAlternative',
                '|',
                'linkImage'
            ]
        },
        link: { addTargetToExternalLinks: true },
      },
      comment: "",
      loader: false,
    };
  },
  props: {
    ticket: {
      type: Object,
      default: function () { return {} }
    }
  },
  methods: {
    back() {
      this.$router.push("/vip_sonko/tickets");
    },
    save() {

      const self = this;
      this.$validator.validateAll().then(isValid => {
        if (isValid) {          
          if(this.comment == undefined || this.comment == null || this.comment.length == 0){
            this.$refs.mySnackbar.show("Please enter reply", "red");
          } else{
            const ticketData = {
              userId: this.user._id,
              comments: this.comment,
              ticketId: this.ticket._id,
            };
            const formData = new FormData();
            formData.append("options", JSON.stringify(ticketData));
            const data = formData;
            this.loader = true;
            const self = this;
            const res = this.$store
              .dispatch("post", { url: "/ticketreply", data })
              .then(res => {
                self.loader = false;
                location.reload();
            });
          }
        }
      });
    },
  }
  /*mounted() {
    setInterval(() => document.title = this.job.title, 1000);
  },
  updated() {
    setInterval(() => document.title = this.job.title, 1000);
  }*/
};
</script>


<style scoped>
p {
  font-size: 16px;
}
</style>
